var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Left icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 17.5L14.3333 16.3125L15.6458 15H10.5V13.3333H15.6458L14.3333 12L15.5 10.8333L18.8333 14.1666L15.5 17.5ZM18 8.33331H16.3333V4.16665H14.6667V6.66665H6.33333V4.16665H4.66667V15.8333H8.83333V17.5H3V2.49998H8.14583C8.29861 2.01387 8.59722 1.61443 9.04167 1.30165C9.48611 0.98887 9.97222 0.832759 10.5 0.833314C11.0556 0.833314 11.5522 0.989703 11.99 1.30248C12.4278 1.61526 12.7228 2.01443 12.875 2.49998H18V8.33331ZM10.5 4.16665C10.7361 4.16665 10.9342 4.08665 11.0942 3.92665C11.2542 3.76665 11.3339 3.56887 11.3333 3.33331C11.3333 3.0972 11.2533 2.89915 11.0933 2.73915C10.9333 2.57915 10.7356 2.49943 10.5 2.49998C10.2639 2.49998 10.0658 2.57998 9.90583 2.73998C9.74583 2.89998 9.66611 3.09776 9.66667 3.33331C9.66667 3.56943 9.74667 3.76748 9.90667 3.92748C10.0667 4.08748 10.2644 4.1672 10.5 4.16665Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left-icon.8b0444c02323c8c5230347efb118bacd.svg";
export { ForwardRef as ReactComponent };